/* eslint-disable max-len */
export const MobileAppDownload = "/MobileAppDownload";
export const MobileAppDownloadShort = "/app";
export const MobileAppDownloadPrefixed = { url: "/karta%7Bcampaign%7D", type: undefined as { campaign: string | number; } };
export const AppleAppAssociation = "/apple-app-association";
export const AppleAppSiteAssociation = "/apple-app-site-association";
export const GetShareUrl = { url: "/common/GetShareUrl/%7BshareType%7D", type: undefined as { shareType: string | number; } };
export const GetEmailShareUrl = { url: "/common/GetEmailShareUrl/%7BshareType%7D", type: undefined as { shareType: string | number; } };
export const VoucherPage = { url: "/voucher/%7Bcode%7D", type: undefined as { code: string | number; } };
export const Common = { url: "/api/common/%7Baction%7D", type: undefined as { action: string | number; } };
